module.exports = __webpack_public_path__ + "static/media/Screen Shot 2021-10-12 at 9.47.59 PM.62e7635c.png";